function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M20 22.4c-.8 0-1.7-.3-2.4-1l-3.8-3.8a3.5 3.5 0 010-5c.6-.6 1.5-1 2.4-1 1 0 1.9.4 2.5 1l.4.4-.8.9-.4-.4c-.4-.5-1-.7-1.7-.7-.6 0-1.1.2-1.6.7-.4.4-.7 1-.7 1.6 0 .6.3 1.2.7 1.7l3.8 3.8c.8.8 2 .9 3 .3.3-.2.6-.1.8.1.2.3 0 .7-.2.8-.6.4-1.3.6-2 .6z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M24.5 26.8c-1 0-1.8-.3-2.5-1l-.3-.4a.6.6 0 01.8-.8l.4.4c.4.4 1 .7 1.6.7.6 0 1.2-.3 1.6-.7.5-.5.7-1 .7-1.7 0-.6-.2-1.2-.6-1.6l-3.9-3.8c-.8-1-2.2-.9-2.9-.3a.6.6 0 01-.7-1c1.2-.8 3.1-.9 4.5.4L27 21a3.5 3.5 0 010 4.9c-.7.6-1.6 1-2.5 1zM21.6 8.2H4A4 4 0 014 0h17.5a4 4 0 010 8.2zM4 1.2A3 3 0 004 7h17.5a3 3 0 000-5.8H4z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5.2 5.8a1.7 1.7 0 110-3.5 1.7 1.7 0 010 3.5zm0-2.3a.6.6 0 100 1.2.6.6 0 000-1.2zM11 5.8a1.7 1.7 0 110-3.5 1.7 1.7 0 010 3.5zm0-2.3a.6.6 0 100 1.2.6.6 0 000-1.2zM9.9 15.1H4.1A4 4 0 014 7h17.5a4 4 0 012.4 7.3c-.3.2-.6.2-.8-.1a.6.6 0 01.1-.8l.3-.3c.6-.5.9-1.3.9-2a3 3 0 00-3-3H4.2a2.9 2.9 0 00-3 3 3 3 0 003 2.9h5.8a.6.6 0 010 1.1z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5.2 12.8a1.7 1.7 0 110-3.5 1.7 1.7 0 010 3.5zm0-2.3a.6.6 0 100 1.2.6.6 0 000-1.2zM11 12.8a1.7 1.7 0 110-3.5 1.7 1.7 0 010 3.5zm0-2.3a.6.6 0 100 1.2.6.6 0 000-1.2zM13.4 22.1H4.1A4 4 0 014 14h5.8a.6.6 0 010 1.1H4.1a2.9 2.9 0 00-3 3 3 3 0 003 2.9h9.3a.6.6 0 010 1.1z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5.2 19.8a1.7 1.7 0 110-3.5 1.7 1.7 0 010 3.5zm0-2.3a.6.6 0 100 1.1.6.6 0 000-1.1zM11 19.8a1.7 1.7 0 010-3.5.6.6 0 010 1.2.6.6 0 000 1.1.6.6 0 010 1.2z"
});

function SvgIconConnectAws(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 27,
    fill: "none",
    viewBox: "0 0 28 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConnectAws);
export default __webpack_public_path__ + "static/media/icon-connect-aws.bcfd8c0f.svg";
export { ForwardRef as ReactComponent };